{
  "FILTER": {
    "TITLE": "تصفية المحادثات",
    "SUBTITLE": "أضف عوامل التصفية أدناه واضغط على 'تطبيق التصفيات' لتجنب الفوضى في المحادثات.",
    "EDIT_CUSTOM_FILTER": "تعديل المجلد",
    "CUSTOM_VIEWS_SUBTITLE": "أضف أو أزل تصفيات وقم بتحديث المجلد الخاص بك.",
    "ADD_NEW_FILTER": "إضافة تصفية",
    "FILTER_DELETE_ERROR": "عذرًا، يبدو أننا لا نستطيع حفظ أي شيء! يرجى إضافة تصفية واحدة على الأقل ليتم الحفظ.",
    "SUBMIT_BUTTON_LABEL": "تطبيق التصفيات",
    "UPDATE_BUTTON_LABEL": "تحديث المجلد",
    "CANCEL_BUTTON_LABEL": "إلغاء",
    "CLEAR_BUTTON_LABEL": "مسح التصفيات",
    "FOLDER_LABEL": "اسم المجلد",
    "TEAMS_LABEL": "مشاركة مع",
    "PARENT_FOLDER_LABEL": "المجلد الرئيسي",
    "NO_PARENT_FOLDER": "بدون مجلد رئيسي",
    "COLOR_LABEL": "اللون",
    "SELECT_COLOR": "اختر اللون",
    "CLEAR_SELECTION": "مسح التحديد",
    "SORT_BY_LABEL": "الترتيب حسب",
    "FOLDER_QUERY_LABEL": "استعلام المجلد",
    "EMPTY_VALUE_ERROR": "القيمة مطلوبة.",
    "TOOLTIP_LABEL": "تصفية المحادثات",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "و",
      "OR": "أو"
    },
    "INPUT_PLACEHOLDER": "أدخل القيمة",
    "OPERATOR_LABELS": {
      "present": "موجود",
      "not_present": "غير موجود",
      "present_with_answer": "موجود مع رد",
      "present_without_answer": "موجود بدون رد",
      "equal_to": "يساوي",
      "not_equal_to": "لا يساوي",
      "does_not_contain": "لا يحتوي",
      "is_present": "موجود",
      "is_not_present": "غير موجود",
      "is_greater_than": "أكبر من",
      "is_less_than": "أقل من",
      "is_greater_than_or_equal": "أكبر من أو يساوي",
      "is_less_than_or_equal": "أصغر من أو يساوي",
      "newer_than_days": "أحدث من x يوم (شاملاً)",
      "older_than_days": "أقدم من x يوم (شاملاً)",
      "starts_with": "يبدأ بـ",
      "equalTo": "يساوي",
      "notEqualTo": "لا يساوي",
      "contains": "يحتوي",
      "doesNotContain": "لا يحتوي",
      "isPresent": "موجود",
      "isNotPresent": "غير موجود",
      "isGreaterThan": "أكبر من",
      "isLessThan": "هو أقل من",
      "startsWith": "يبدأ بـ"
    },
    "ATTRIBUTE_LABELS": {
      "TRUE": "صحيح",
      "FALSE": "خاطئ"
    },
    "ATTRIBUTES": {
      "STATUS": "الحالة",
      "ASSIGNEE_NAME": "اسم المكلَّف",
      "INBOX_NAME": "اسم صندوق الوارد",
      "TEAM_NAME": "اسم الفريق",
      "CONVERSATION_IDENTIFIER": "معرف المحادثة",
      "CAMPAIGN_NAME": "اسم الحملة",
      "LABELS": "الوسوم",
      "BROWSER_LANGUAGE": "لغة المتصفح",
      "PRIORITY": "الأولوية",
      "COUNTRY_NAME": "اسم الدولة",
      "REFERER_LINK": "رابط المرجع",
      "CUSTOM_ATTRIBUTE_LIST": "القائمة",
      "CUSTOM_ATTRIBUTE_TEXT": "النص",
      "CUSTOM_ATTRIBUTE_NUMBER": "العدد",
      "CUSTOM_ATTRIBUTE_LINK": "الرابط",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "خانة الاختيار",
      "CREATED_AT": "تم إنشاؤها في",
      "LAST_ACTIVITY": "آخر نشاط",
      "LAST_CUSTOMER_MESSAGE_AT": "آخر رسالة من العميل",
      "PHONE_CALL": "مكالمة هاتفية",
      "RATING": "التقييم",
      "CSAT": "CSAT"
    },
    "PHONE_CALL_TYPES": {
      "INBOUND": "واردة",
      "OUTBOUND": "صادرة",
      "MISSED": "فائتة",
      "UNHANDLED_MISSED": "فائتة دون معالجة"
    },
    "RATING_TYPES": {
      "UP": "إعجاب",
      "DOWN": "عدم إعجاب"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "القيمة مطلوبة",
      "ATTRIBUTE_KEY_REQUIRED": "مفتاح الخاصية مطلوب",
      "FILTER_OPERATOR_REQUIRED": "عامل التصفية مطلوب",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "يجب أن تكون القيمة بين 0 و998",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "القيمة يجب أن تكون بين 1 و 998"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "التصفيات القياسية",
      "ADDITIONAL_FILTERS": "التصفيات الإضافية",
      "CUSTOM_ATTRIBUTES": "الخصائص المخصصة"
    },
    "CUSTOM_VIEWS": {
      "ADD": {
        "TITLE": "هل تريد حفظ هذه التصفية؟",
        "LABEL": "تسمية هذه التصفية",
        "PLACEHOLDER": "قم بتسمية التصفية لتتمكن من الرجوع إليه لاحقًا.",
        "ERROR_MESSAGE": "الاسم مطلوب.",
        "SAVE_BUTTON": "حفظ التصفية",
        "CANCEL_BUTTON": "إلغاء",
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "تم إنشاء المجلد بنجاح.",
          "ERROR_MESSAGE": "حدث خطأ أثناء إنشاء المجلد."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "تم إنشاء القسم بنجاح.",
          "ERROR_MESSAGE": "حدث خطأ أثناء إنشاء القسم."
        }
      },
      "EDIT": {
        "EDIT_BUTTON": "تحرير المجلد",
        "API_FOLDERS": {
          "ERROR_MESSAGE": "حدث خطأ أثناء تحديث المجلد."
        }
      },
      "DELETE": {
        "DELETE_BUTTON": "حذف التصفية",
        "MODAL": {
          "CONFIRM": {
            "TITLE": "تأكيد الحذف",
            "MESSAGE": "هل أنت متأكد من حذف التصفية ",
            "YES": "نعم، احذف",
            "NO": "لا، احتفظ به"
          }
        },
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "تم حذف المجلد بنجاح.",
          "ERROR_MESSAGE": "حدث خطأ أثناء حذف المجلد."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "تم حذف القسم بنجاح.",
          "ERROR_MESSAGE": "حدث خطأ أثناء حذف القسم."
        }
      }
    }
  }
}
